<template>
  <el-dialog :title="$t('message.setDefaultSealer')" :visible.sync="visible" width="460px" center
    :close-on-click-modal="false" :close-on-press-escape="!saving" :show-close="!saving">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" class="sealer-form">
      <el-form-item :label="$t('message.defaultSealer') + '：'" prop="sealer_id">
        <el-select v-model="form.sealer_id" filterable clearable :loading="loading" :disabled="loading || saving"
          :placeholder="$t('message.selectDefaultSealer')" @change="resetProgress">
          <el-option v-for="item in candidates" :key="item.id" :label="item.realname" :value="item.id" />
        </el-select>
      </el-form-item>
      <div v-if="loadError" class="load-error">
        {{ $t('message.sealerCandidatesLoadFailed') }}
        <el-button type="text" @click="loadCandidates">{{ $t('message.reloadSealerCandidates') }}</el-button>
      </div>
    </el-form>
    <div v-if="progress.total" class="sealer-progress" :class="{ 'is-failed': progress.failed }">
      <div class="progress-head">
        <span>{{ $t('message.defaultSealerProgress') }}</span>
        <span class="progress-count">
          {{ progress.current }} / {{ progress.total }}
          <i v-if="progress.failed" class="el-icon-circle-close" aria-hidden="true"></i>
        </span>
      </div>
      <el-progress :percentage="progressPercentage" :stroke-width="8" :show-text="false"
        :status="progress.failed ? 'exception' : undefined" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="saving" :disabled="!canSet || loading || loadError" @click="save">
        {{ $t('message.immediateAdjustment') }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    canSet: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      loading: false,
      saving: false,
      loadError: false,
      adminIds: [],
      progress: { current: 0, total: 0, failed: false },
      candidates: [],
      form: { sealer_id: '' },
      rules: {
        sealer_id: [{
          validator: (rule, value, callback) => {
            if (!Number.isInteger(value) || value <= 0 || !this.candidates.some(item => item.id === value)) {
              return callback(new Error(this.$t('message.selectDefaultSealer')))
            }
            callback()
          },
          trigger: 'change',
        }],
      },
    }
  },
  computed: {
    progressPercentage() {
      if (!this.progress.total) return 0
      return Math.round(this.progress.current / this.progress.total * 100)
    },
  },
  methods: {
    // 每次打开均不预选封箱人，不排除候选接口中符合条件的本人。
    open(list) {
      if (!this.canSet || this.saving) return
      if (!list.length) return this.$message.error(this.$t('message.pleaseSelectAtLeastOne'))
      this.adminIds = [...new Set(list.map(item => Number(item.id)))]
      this.form.sealer_id = ''
      this.resetProgress()
      this.candidates = []
      this.visible = true
      this.$nextTick(() => this.$refs.form.clearValidate())
      this.loadCandidates()
    },
    async loadCandidates() {
      if (!this.canSet || this.loading) return
      this.loading = true
      this.loadError = false
      try {
        const res = await this.$api.porderApi.sealingCandidates()
        if (res.code !== 0 || res.success === false) throw new Error(res.msg)
        this.candidates = res.data
      } catch (error) {
        this.loadError = true
      } finally {
        this.loading = false
      }
    },
    // 更换封箱人表示新一轮设置，重新统计全部选中账号。
    resetProgress() {
      this.progress = { current: 0, total: 0, failed: false }
    },
    save() {
      if (!this.canSet || this.saving || this.loading || this.loadError) return
      // 校验开始前锁定，避免连续点击同时进入提交。
      this.saving = true
      this.$refs.form.validate(async (valid) => {
        if (!valid || !this.canSet) {
          this.saving = false
          return
        }
        this.progress.total = this.adminIds.length
        this.progress.failed = false
        let saved = false
        try {
          let res = null
          // 多选时逐个调用；已成功的账号不再提交，失败后停止，不自动重试。
          for (let i = this.progress.current; i < this.adminIds.length; i++) {
            res = await this.$api.roleApi.setDefaultSealer({
              admin_id: this.adminIds[i],
              sealer_id: this.form.sealer_id,
            })
            if (res.code != 0 || res.success === false) {
              this.progress.failed = true
              return
            }
            this.progress.current += 1
            saved = true
          }
          this.$message.success(res.msg)
          this.visible = false
        } catch (error) {
          this.progress.failed = true
          // 接口错误由公共请求层提示，避免组件再次弹出相同提示。
        } finally {
          this.saving = false
          if (saved) this.$emit('saved')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sealer-form {
  padding: 10px 20px 0;

  .el-select {
    width: 100%;
  }
}

.load-error {
  color: #f56c6c;
  text-align: center;
}

.sealer-progress {
  margin: 20px 20px 0;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #f7f8fa;

  .progress-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    color: #606266;
    font-size: 14px;
    line-height: 20px;
  }

  .progress-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
  }

  &.is-failed {
    border-color: #fde2e2;
    background: #fef0f0;

    .progress-head {
      color: #f56c6c;
    }
  }
}
</style>
